<template>
    <main-section class="main-section--sm">
        <swiper class="swiper" :options="options">
            <swiper-slide v-for="(item, index) in items" :key="index">
                <img :src="item.image" :alt="item.name" class="product-image" />
                <div class="logo-wrap">
                    <img :src="item.logo" :alt="item.company" />
                </div>
            </swiper-slide>
        </swiper>
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import SquareTitle from "../dumb/square-title.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        MainSection,
        SquareTitle,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            options: {
                allowTouchMove: true,
                spaceBetween: 20,
                slidesPerView: 2,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 500,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                },
            },
            items: [
                {
                    name: "투윅스 체인지 메타",
                    image: "/images/main/products/product-1.jpg",
                    company: "LIFE'S KEY",
                    logo: "/images/main/products/logo-1.svg",
                },
                {
                    name: "팜스 슈퍼 트리오틱스",
                    image: "/images/main/products/product-2.jpg",
                    company: "LIFE'S KEY", 
                    logo: "/images/main/products/logo-1.svg",
                },
                {
                    name: "에리스아미노",
                    image: "/images/main/products/product-3.jpg",
                    company: "NUTROPIA INC",
                    logo: "/images/main/products/logo-2.svg",
                },
                {
                    name: "진부참당귀유산균",
                    image: "/images/main/products/product-4.jpg",
                    company: "농협",
                    logo: "/images/main/products/logo-3.svg",
                },
                {
                    name: "두힐고흥 유자유산균",
                    image: "/images/main/products/product-5.jpg",
                    company: "농협",
                    logo: "/images/main/products/logo-3.svg",
                },
                {
                    name: "진짜 땡땡 유산균",
                    image: "/images/main/products/product-6.jpg",
                    company: "농협",
                    logo: "/images/main/products/logo-3.svg",
                },
                {
                    name: "미뉴트리 요거트 스타터",
                    image: "/images/main/products/product-7.jpg",
                    company: "ROICHEN",
                    logo: "/images/main/products/logo-4.svg",
                },
                {
                    name: "참 유산균 강아지",
                    image: "/images/main/products/product-8.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                {
                    name: "참 유산균 고양이",
                    image: "/images/main/products/product-9.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                {
                    name: "참 글루칸",
                    image: "/images/main/products/product-10.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                { 
                    name: "참 시스토캄",
                    image: "/images/main/products/product-11.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                {
                    name: "강아지용 참 면역케어",
                    image: "/images/main/products/product-12.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                {
                    name: "고양이용 참 면역케어",
                    image: "/images/main/products/product-13.jpg",
                    company: "peppytail",
                    logo: "/images/main/products/logo-5.svg",
                },
                {
                    name: "핑크소금 유산균",
                    image: "/images/main/products/product-14.jpg",
                    company: "솔트뱅크",
                    logo: "/images/main/products/logo-6.svg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.main-section {
    background-color: rgb(251, 251, 251);
}
.product-image,
.logo-wrap {
    border-radius: 12px;
    @media (min-width: 768px) {
        border-radius: 18px;
    }
    @media (min-width: 1024px) {
        border-radius: 24px;
    }
}
.product-image {
    display: block;
    margin: 0 auto;
}
.logo-wrap {
    border: 1px solid var(--v-primary-base);
    overflow: hidden;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    margin-top: 6px;
    > img {
        display: block;
        margin: 0 auto;
        max-width: 120px;
    }
    @media (min-width: 768px) {
        margin-top: 8px;
        > img {
            max-width: 160px;
        }
    }
    @media (min-width: 1024px) {
        height: 100px;
        > img {
            max-width: 216px;
        }
    }
}

.swiper-container {
    overflow: visible;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 50vw;
        height: 100%;
        background-color: rgb(251, 251, 251);
        z-index: 2;
        transform: translateX(-100%);
    }
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
</style>